export type ProductType = 'SERVICO' | 'ESPACO_COMODIDADE' | 'OUTRO';

export const ProductTypeLabels: Record<ProductType, string> = {
  SERVICO: 'Serviço',
  ESPACO_COMODIDADE: 'Espaço/Comodidade',
  OUTRO: 'Outro',
};

export interface ProductApi {
  id: string;
  name: string;
  description: string;
  price: string;        // o back devolve "1000" como string
  type: ProductType;    // tipo do produto
  isRecurring: boolean; // novo campo
  recurringInterval: string;
  coworkingId: string;
  createdAt: string;    // ISO string
  updatedAt: string;    // ISO string
}